import { Drawer, DialogContent, Button } from "@wayfarer/components";
import CloseOutlined from "@mui/icons-material/Close";
import React from "react";

interface NotificationsDrawerProps {
  isOpen: boolean;
  onClickClose: () => void;
}

const NotificationsDrawer: React.FC<NotificationsDrawerProps> = ({
  isOpen,
  onClickClose,
}) => {
  return (
    <Drawer open={isOpen} onClose={onClickClose} modal shadow={true}>
      <DialogContent
        role="dialog"
        aria-modal="true"
        title="Notifications"
        dividers
        headerButtonEnd={id => (
          <Button
            motif="tertiary"
            icon={() => <CloseOutlined />}
            aria-label="close"
            aria-controls={id}
            onClick={onClickClose}
          />
        )}>
        <div>
          <p>
            This is a <strong>modal drawer</strong>. You cannot interact with
            the page behind it.
          </p>
          <ul>
            <li>Has a backdrop overlay</li>
            <li>Blocks page interaction</li>
            <li>Has a shadow effect</li>
            <li>Can be closed by clicking the X button</li>
          </ul>
        </div>
      </DialogContent>
    </Drawer>
  );
};

export default NotificationsDrawer;
